import axios from 'axios';
import { URL } from '../../util/ambienteActions';
import {montarURLFiltro} from '../../util/filtros';

export const TOTALIZADORES_CENTRO_CUSTO = 'TOTALIZADORES_CENTRO_CUSTO';

export default function buscarTotalizadoresCentroCusto(empresaId, registrosPorPagina, filtros = {}) {
    const urlFiltros = montarURLFiltro(filtros, 1, registrosPorPagina);
    const url = `${URL}/centro-custo/empresa/${empresaId}/totalizadores${urlFiltros}`;
    return dispatch => {
        return axios.get(url)
            .then(response => {
                dispatch({ type: TOTALIZADORES_CENTRO_CUSTO, payload: response.data });
            });
    };
}
